import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-back-navigation',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './back-navigation.component.html',
  styleUrl: './back-navigation.component.scss'
})
export class BackNavigationComponent {
  @Input() backTitle!: string;
  @Input() action!: string;
  @Input() actionIconClass!: string;
  @Output() onClickBack = new EventEmitter<void>();
  @Output() onClickAction = new EventEmitter<void>();

  onClickBackButton() {
    this.onClickBack.emit();
  }
  onClickActionButton() {
    this.onClickAction.emit();
  }

}
